// Matching backend regex:
//  - File: /WD.Gibraltar/IdentityTheftMonitoring/IdentityTheftMonitoring/Common/EmailAddressValidator.cs
//  - Commit: b9fb93222a647132f3fbaacd6d77ff814a95eb0e
//  - Line: 28
export const emailRegex =
  /^(?:[a-zA-Z0-9_%+!#$&'*/=?^`{|}~-](?:\.?[a-zA-Z0-9_%+!#$&'*/=?^`{|}~-])*)(?:@[a-zA-Z0-9_%+!#$&'*/=?^`{|}~-](?:\.?[a-zA-Z0-9_%+!#$&'*/=?^`{|}~-])*)(?:\.[a-zA-Z]+)$/;

/**
 * TODO: following regex's are only used temporarily until UX design is determined
 */
// Country code (2-letter)
export const countryCodeRegex = /^[a-zA-Z]{2}$/;
// National ID
export const nationalIdRegex = /^[a-zA-Z0-9]{5,30}$/;
// Driver license
export const driverLicenseRegex = /^[a-zA-Z0-9]+$/;
// Medical ID
export const medicalIdRegex = /^[a-zA-Z0-9]+$/;
// IBAN
export const ibanRegex = /^[a-zA-Z0-9]{16,34}$/;
// Other card
export const otherCardRegex = /^[0-9]{8,16}$/;
// Passport
export const passportRegex = /^[a-zA-Z0-9]{1,88}$/;
// Bank account routing
export const bankAccountRoutingRegex = /^[a-zA-Z0-9]{1,30}$/;
// Bank account number
export const bankAccountNumberRegex = /^[a-zA-Z0-9]{4,34}$/;
// Credit card
export const creditCardRegex = /^[0-9]{15,16}$/;
// Debit card
export const debitCardRegex = /^[0-9]{13,19}$/;
// SSN
export const ssnRegex = /^[0-9]{3}-[0-9]{2}-[0-9]{4}$/;
// Zip code
export const zipCodeRegex = /^[0-9]{5}$/;
